import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class CampSiege1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.CAMP_SIEGE1;
}

export default CampSiege1PoiTileEntity;
